import { render, staticRenderFns } from "./AppraisalResidualRiskDrillDown.vue?vue&type=template&id=346e2cdf&scoped=true&"
import script from "./AppraisalResidualRiskDrillDown.vue?vue&type=script&lang=ts&"
export * from "./AppraisalResidualRiskDrillDown.vue?vue&type=script&lang=ts&"
import style0 from "./AppraisalResidualRiskDrillDown.vue?vue&type=style&index=0&id=346e2cdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346e2cdf",
  null
  
)

export default component.exports